'use strict';

// This class attempts to centralize some functionality for the insights widgets.
// Add to it as you're able!
angular.module('MW.InsDashboard.TransformSentimentScore', [
    'DashboardChartConfigService',
    'MW.InsDashboard.ChartDataService'
])
.factory('TransformSentimentScore', [
    'DashboardChartConfigService',
    'ChartDataService',
    function (
        DashboardChartConfigService,
        ChartDataService) {

    var serviceObj = {};

    var processChart = function(data, requestQuery){
        var category =  ChartDataService.setDateAxis(data[0].datapoints, requestQuery); //set x axis date labels
        
        ChartDataService.setDateSeriesWithLabel(data, formatSovDataPoint, requestQuery).then(function(data) {
            var config = {
                xAxis:{
                    type: 'category',
                    categories:category
                },
                series: data
            };

            /*
            * disable x axis legend when comparing date ranges
            */
            if (requestQuery.fetchDataForPreviousRange) {
                config.xAxis['labels'] = {
                    enabled: false
                };
            }
            requestQuery.callback(config);
        });
    };
    serviceObj.chartByInput = processChart;

    var formatSovDataPoint = function(thisPoint, allPoints, index, requestQuery){
        var dataPoint = requestQuery.dataMap(thisPoint),
            point = {
                x: index,
                y:dataPoint.y || 0,
                indx:index,
                date: (thisPoint.hasOwnProperty('date')) ? thisPoint.date: null, //try to get the date if it exists so that we can use it for drilldowns
                insightsPointData:dataPoint //if another widget wants to use this chart with another data request, all point data is here for flexibility... example, use on tooltip...
            };

        return point;
    };

    var processTable = function processTable(data, chart){
        var responseData = {},
            tableData = [],
            tableSovSummary = [],
            tableCountSummary = [],
            pointCount = data[0].totalDatapoints,
            colTotals = [],
            rowTotals = [],
            periodTotal = 0;

        for(var i = 0; i < data.length; i++) {
            colTotals[i] = 0;
        }

        //Calculate Totals
        for(var rowIndex = 0; rowIndex < pointCount; rowIndex++){
            rowTotals[rowIndex] = 0;
            for(var colIndex = 0; colIndex < data.length; colIndex++){
                rowTotals[rowIndex] += data[colIndex].datapoints[rowIndex].average;
                colTotals[colIndex] += data[colIndex].datapoints[rowIndex].average;
                periodTotal += data[colIndex].datapoints[rowIndex].average;
            }
        }

        //Calculate Cell SOVs
        for(var rowIndex = 0; rowIndex < pointCount; rowIndex++){
            var tableRow = {data:[]};

            //Set Label
            tableRow.label = DashboardChartConfigService.formatTimeInterval(moment(data[0].datapoints[rowIndex].date),chart.queryParameters.granularity, chart.queryParameters.dateStart, chart.queryParameters.dateEnd);

            for(var colIndex = 0; colIndex < data.length; colIndex++){
                var datapoint = {
                    name: data[colIndex].search.name,
                    average: (data[colIndex].datapoints[rowIndex].average).toFixed(1),
                    date: data[colIndex].datapoints[rowIndex].date,
                    id: data[colIndex].search.id,
                    sentiment_score: (data[colIndex].datapoints[rowIndex].average).toFixed(1)
                };
                tableRow.data.push(datapoint);
            }
            tableData.push(tableRow);
        }

        //Calculate Period SOVs
        for(var colIndex = 0; colIndex < data.length; colIndex++){
            var colSov = ((colTotals[colIndex] / periodTotal) * 100).toFixed(1) + '%';
            tableSovSummary.push(colSov);
            tableCountSummary.push((colTotals[colIndex]).toFixed(1));
        }

        responseData.table = tableData;

        if(chart.percentageMode == true){
            // In percent mode as well, Sentiment score total value remains same as count value;
            responseData.summary = tableCountSummary;
        } else {
            responseData.summary = tableCountSummary;
        }

        chart.callback(responseData);
    };

    serviceObj.table = processTable;

    return serviceObj;

}]);
